module.exports = __webpack_public_path__ + "static/media/toggle-on.1be73884.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photobooks/toggle-on.svg
// module id = 1729
// module chunks = 68